module.exports = __webpack_public_path__ + "static/media/lemon_and_lime.085ea12e.png";